<template>
  <!-- Let the router load FrontLayout or AdminLayout as needed -->
  <router-view />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'App'
})
</script>
